import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { logout } from 'redux/users/actions';

import { Link } from 'react-router-dom';
import onClickOutside from 'react-onclickoutside';

import CommonUserIcon from 'components/dashboard/common/CommonUserIcon';
import CommonUnlockProBtn from 'components/dashboard/common/CommonUnlockProBtn';

import './MyAccount.css';


class MyAccount extends Component {
  static propTypes = {
    logout: PropTypes.func.isRequired,
    me: PropTypes.object,
  };

  static defaultProps = {
    me: null,
  };

  state = {
    showPopup: false,
  };

  handleClickOutside = () => {
    this.setState({ showPopup: false });
  }

  render() {
    const { me, logout } = this.props;
    const { showPopup } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="dahsboard-my-account__component">
            <div className="user-icon">
              <CommonUserIcon
                onClick={() => {
                  this.setState({ showPopup: !showPopup });
                }}
              />
            </div>
    
            {showPopup &&
              <div className="my-account-popup">
    
                <div className="account-info">
                  <div className="username">{me.username}</div>
                  <div className="email">{me.email}</div>
                </div>
    
                <CommonUnlockProBtn />
    
                <Link
                  className="action-item"
                  to="/appearance"
                  onClick={() => this.setState({ showPopup: false })}
                  role="link"
                  tabIndex={-1}
                >
                  <div className="icon appearance" />
                  <div className="text">{t("Appearance")}</div>
                </Link>
    
                <Link
                  className="action-item"
                  to="/security"
                  onClick={() => this.setState({ showPopup: false })}
                  role="link"
                  tabIndex={-1}
                >
                  <div className="icon security" />
                  <div className="text">{t("Password & Security")}</div>
                </Link>
    
                <Link
                  className="action-item"
                  to="/billing"
                  onClick={() => this.setState({ showPopup: false })}
                  role="link"
                  tabIndex={-1}
                >
                  <div className="icon billing" />
                  <div className="text">{t("Billing & Subscription")}</div>
                </Link>
    
                <Link
                  className="action-item"
                  to="#"
                  onClick={logout}
                >
                  <div className="icon logout" />
                  <div className="text">{t("Log out")}</div>
                </Link>
              </div>
            }
    
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    logout,
  },
)(onClickOutside(MyAccount));
